module.exports = __webpack_public_path__ + "assets/ShortTermAccidentTemplate-82d336783a1efbce9ca721be00e7b7bb.xlsx";